import {
  CRYPTO_PAYMENT,
  CRYPTO_PAYMENT_SUCCESS,
  CRYPTO_PAYMENT_FAILURE,
} from "../../Action/actionTypes";

const INIT_STATE = {
  loading: false,
  details: {},
};

const loginReducer = (state = INIT_STATE, action) => {
  switch (action.type) {
    case CRYPTO_PAYMENT:
      return { ...state, loading: true };
    case CRYPTO_PAYMENT_SUCCESS:
      return {
        ...state,
        details: action?.payload,
        loading: false,
      };
    case CRYPTO_PAYMENT_FAILURE:
      return { ...state, loading: false };
    default:
      return state;
  }
};

export default loginReducer;
